import JointForm from "components/addcustomer/joint/jointfrom";
import Nextkinfrom from "components/addcustomer/nextkin/nextkinfrom";
import Notificationfrom from "components/addcustomer/notification/notificationfrom";
import AddCustomerLayout from "components/global/customerlayout/AddCustomerLayout";
import { useRef } from "react";
import { useNavigate ,useParams} from "react-router-dom";
import { useSelector } from "react-redux";
import { PulseLoader } from "react-spinners";



const CusomerNotification = () => {
    const { id } = useParams();
      const formRef = useRef(); 
           const { createCustomerNotificationLoading } = useSelector(state => state.customer);
    
const navigate=useNavigate();
    const customerId = 1; 


    const   dynamicName=(
        <div className="flex flex-col gap-1.5">
          <h2 className="page-heading">New Customer</h2>
        </div>
    );

      const submitButton = (
      <div className="flex items-center gap-2">
      <button 
       onClick={()=>navigate(`/app/Customer/${id}/documents`)}
      type="button" className="btn-secondary   w-fit">
        Skip
      </button>

        <button
        disabled={createCustomerNotificationLoading}
        type="button"
        className={`btn-primary py-2 px-6 w-fit ${createCustomerNotificationLoading ? "opacity-70 cursor-not-allowed" : ""}`}
        onClick={() => !createCustomerNotificationLoading && formRef.current?.submitForm()}
      >
        {createCustomerNotificationLoading ? (
          <PulseLoader size={12} color="white" />
        ) : (
          "Next / Save"
        )}
      </button>
      {/* <button
        type="button"
        className="btn-primary py-2 px-6 w-fit"
        onClick={() => formRef.current?.submitForm()}
      >
        Next / Save
      </button> */}
    </div>
  );
  return (
    <AddCustomerLayout   dynamicName={dynamicName}  dynmicbutton={submitButton}>
    <Notificationfrom ref={formRef} />
    </AddCustomerLayout>
  )
}

export default CusomerNotification;